// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2Ef64","errorLogs":"EditorFooter_errorLogs__3l__6"};